import { getRouteApi } from '@tanstack/react-router'
import { TableDataQa } from 'commons/types/enums'
import { DataSourceItem, Layer, Table } from 'ui/components'
import { AnnualReviewDetails } from '~bank-annual-review/types/AnnualReviewDetails'

import { columns } from './columns'

type LicensingItem = AnnualReviewDetails['licensingItems'][number]

export const LicensesTable = ({
  routeApi = '/_app/annual-review/detail/$companyId/$id'
}: {
  routeApi?: '/_app/annual-review/edit/$companyId/$id' | '/_app/annual-review/detail/$companyId/$id'
}): JSX.Element | null => {
  const data = getRouteApi(routeApi).useLoaderData()

  if (!data.licensingItems) return null

  const mappedLicensingItems: DataSourceItem<LicensingItem>[] = data.licensingItems.map((el) => ({ item: el }))

  return (
    <Layer rounded shadowed>
      <Table<LicensingItem>
        dataQa={TableDataQa.BP_ANNUAL_REVIEW_LICENSING}
        columns={columns()}
        dataSource={mappedLicensingItems}
      />
    </Layer>
  )
}
